import * as browser from "./base64-browser";
import * as server from "./base64-server";
var nextBase64 = "object" === "undefined" ? server : browser;
var decodeBase64 = nextBase64.decode;
var encodeBase64 = nextBase64.encode;
var decodeToken = function(token) {
    if (!token) {
        return null;
    }
    var base64Url = token.split(".")[1];
    if (!base64Url) {
        return null;
    }
    var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    var decoded = decodeBase64(base64);
    try {
        return JSON.parse(decoded);
    } catch (err) {
        return null;
    }
};
var validToken = function(token) {
    var ref;
    if (!token) {
        return false;
    }
    var exp = (ref = decodeToken(token)) === null || ref === void 0 ? void 0 : ref.exp;
    return exp ? exp * 1000 > Date.now() : false;
};
export { decodeBase64, encodeBase64, decodeToken, validToken };
